class EventData {
  constructor(name) {
    this.name = name;
  }
}

export { EventData };
//# sourceMappingURL=EventData.mjs.map
